import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "rounded-card magicpattern p-8 md:p-16 text-white overflow-hidden" }
const _hoisted_2 = { class: "max-w-2xl mx-auto text-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "inline-block rounded-badge bg-secondary text-primary text-xs font-medium tracking-label uppercase px-3 py-1" }, " Sınırlı Erken Erişim ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", { class: "mt-6 text-3xl md:text-4xl lg:text-5xl font-medium leading-[1] tracking-display" }, " İlk 500 kişiye özel fırsat. ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "mt-6 text-stone text-base md:text-lg leading-relaxed" }, [
  /*#__PURE__*/_createTextVNode(" Bekleme listesine ilk 500 kayıt olan kişiye, lansmanda "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-secondary font-medium" }, "indirimli komisyon ile yatırım fırsatı"),
  /*#__PURE__*/_createTextVNode(" sunulacaktır. ")
], -1)
const _hoisted_6 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      _createElementVNode("form", {
        onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"])),
        class: "mt-10 flex flex-col sm:flex-row gap-3 items-stretch max-w-lg mx-auto"
      }, [
        _withDirectives(_createElementVNode("input", {
          type: "email",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
          required: "",
          placeholder: "E-posta adresin",
          class: "flex-1 px-5 py-4 rounded-btn bg-white text-primary placeholder:text-graphite border border-white focus:outline-none focus:border-secondary"
        }, null, 512), [
          [_vModelText, _ctx.email]
        ]),
        _createElementVNode("button", {
          type: "submit",
          class: "inline-flex items-center justify-center px-6 py-4 rounded-btn border border-secondary bg-secondary text-primary text-base font-medium hover:bg-cream hover:border-cream transition-colors whitespace-nowrap disabled:opacity-60 disabled:cursor-not-allowed",
          disabled: _ctx.loading
        }, _toDisplayString(_ctx.loading ? 'Gönderiliyor…' : 'Listeye Katıl →'), 9, _hoisted_6)
      ], 32),
      (_ctx.message)
        ? (_openBlock(), _createElementBlock("p", {
            key: 0,
            class: _normalizeClass([_ctx.success ? 'text-secondary' : 'text-coral', "text-center mt-6 text-sm font-medium"])
          }, _toDisplayString(_ctx.message), 3))
        : _createCommentVNode("", true)
    ])
  ]))
}